// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"articleSubCategoryList_is-mob__l_OW_","is-desk":"articleSubCategoryList_is-desk__ErmrN","list__item":"articleSubCategoryList_list__item__1iF1s"};